import { useState, useContext, FC, useCallback } from "react";
import CommentsList from "./CommentsList";
import Actions from "./Actions";
import { AuthContext } from "common/context/Auth";
import { useRouter } from "next/router";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import { PublicationContext } from "common/context/Publication";
import { ArticleContext } from "../Context";
import { articleTypes } from "../Context/ArticleContext";

interface CommentsProps {
  id: string;
  comments: any[];
  commentCount: number | undefined;
  addComment: (comment: any, id: string) => Promise<void>;
  setComments: (comments: any[]) => void;
}

const Comments: FC<CommentsProps> = ({
  id,
  comments,
  commentCount,
  setComments,
  addComment,
}) => {
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const { publication } = useContext<publicationTypes>(PublicationContext);
  const router = useRouter();
  const { session, attributes } = useContext<any>(AuthContext);
  const [body, setBody] = useState("");

  const handleAddComment = useCallback(async () => {
    try {
      const blockedusers = [
        "77a309dd-0b3e-4ed1-9efb-87b07fdaffd3",
        "a53176ee-037f-4a98-83eb-2b460975fd72",
        "94ff9c24-835b-4c2a-9140-d14cd191cf63",
      ];

      if (blockedusers.includes(session?.username)) {
        return;
      } else {
        const comment = {
          title: refactoredArticle.title,
          publication: publication,
          author: attributes ? attributes[2].Value : "",
          authorid: session?.username,
          authorEmail: attributes.filter(
            (item: any) => item.Name === "email"
          )[0].Value,
          body: body,
          timestamp: Date.now(),
          id,
          users: [],
          articleUrl: router.asPath,
        };
        setComments([comment, ...comments]); // optimistic update
        await addComment(comment, id);
        setBody("");
      }
    } catch (err) {
      console.log({ err });
    }
  }, [
    session,
    attributes,
    body,
    id,
    addComment,
    publication,
    refactoredArticle,
    router.asPath,
    comments,
    setComments,
  ]);

  const handleBodyChange = (e: any) => {
    setBody(e.target.value);
  };
  const cancelPost = () => {
    setBody("");
  };

  return (
    <>
      <Actions
        cancelPost={cancelPost}
        session={session}
        handleBodyChange={handleBodyChange}
        body={body}
        addComment={handleAddComment}
        commentCount={commentCount ?? 0}
      />
      <CommentsList userId={session?.username} comments={comments} />
    </>
  );
};

export default Comments;
